import React, { useState } from "react";
import axios from "axios";
import { Mail, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function NewsletterSignup({ source = "footer", compact = false, dark = true, ctaLabel = "Start Preparing" }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ kind: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setState({ kind: "error", msg: "Please enter a valid email address." });
      return;
    }
    setState({ kind: "loading", msg: "" });
    try {
      await axios.post(`${API}/subscribe`, { email, source });
      setState({
        kind: "success",
        msg: "You're on the list — expect recruitment updates, prep tips, application guidance and career articles.",
      });
      setEmail("");
      try {
        localStorage.setItem("tdf_newsletter_signed_up", "1");
        window.dispatchEvent(new CustomEvent("tdf-newsletter-signed-up"));
      } catch (e2) { /* ignore */ }
    } catch (err) {
      setState({ kind: "error", msg: "Something went wrong. Please try again." });
    }
  };

  const inputTone = dark
    ? "bg-white/10 border-white/20 text-white placeholder:text-slate-400"
    : "bg-white border-slate-200 text-slate-900 placeholder:text-slate-400";
  const successTone = dark ? "text-emerald-300" : "text-emerald-700";
  const errorTone = dark ? "text-rose-300" : "text-rose-700";

  return (
    <form onSubmit={submit} className={compact ? "space-y-2" : "space-y-3"}>
      <label htmlFor={`nl-${source}`} className="sr-only">Email address</label>
      <div className="relative">
        <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
        <input
          id={`nl-${source}`}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email address"
          aria-label="Email address"
          className={`w-full ${inputTone} border rounded-full pl-10 pr-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#E63B2E] focus:border-transparent`}
          data-testid={`newsletter-email-${source}`}
        />
      </div>
      <button
        type="submit"
        disabled={state.kind === "loading"}
        className="w-full btn-pill btn-primary text-sm !py-2.5 disabled:opacity-60"
        data-testid={`newsletter-submit-${source}`}
      >
        {state.kind === "loading" ? "Subscribing…" : ctaLabel}
      </button>
      {state.kind === "success" && (
        <p className={`${successTone} text-xs flex items-start gap-1.5`} data-testid={`newsletter-success-${source}`}>
          <CheckCircle2 className="w-3.5 h-3.5 mt-0.5 shrink-0" /> {state.msg}
        </p>
      )}
      {state.kind === "error" && (
        <p className={`${errorTone} text-xs`} data-testid={`newsletter-error-${source}`}>{state.msg}</p>
      )}
    </form>
  );
}
